// removed by extract-text-webpack-plugin
module.exports = {"container":"devtools__container-1MTx3","button":"devtools__button-1xJKx blocks__big-2DxLx blocks__green-2w7kK blocks__button-1iODk","state":"devtools__state-9lkSc devtools__button-1xJKx blocks__big-2DxLx blocks__green-2w7kK blocks__button-1iODk"};


//////////////////
// WEBPACK FOOTER
// ./components/devtools/component.css
// module id = 833
// module chunks = 0